import { CircleOff, SearchX, ServerOff } from "lucide-react";
import type { StorefrontViewState } from "../contexts/StorefrontContext";

const content: Partial<Record<StorefrontViewState, { eyebrow: string; title: string; description: string }>> = {
  "tenant-not-found": {
    eyebrow: "Store not found",
    title: "We could not find this storefront",
    description: "Check the address, or choose an active store from the Elmor POS directory."
  },
  "storefront-disabled": {
    eyebrow: "Storefront disabled",
    title: "This online store is currently closed",
    description: "The business has not enabled online shopping at this address."
  },
  "tenant-unavailable": {
    eyebrow: "Store unavailable",
    title: "This storefront is temporarily unavailable",
    description: "The store cannot accept online visits right now. Please try again later."
  },
  "api-error": {
    eyebrow: "Connection problem",
    title: "We could not load this store",
    description: "The store service is not responding. Check your connection and try again."
  },
  "invalid-tenant": {
    eyebrow: "Invalid store address",
    title: "This address is not a tenant storefront",
    description: "Reserved and infrastructure subdomains cannot be used as store addresses."
  }
};

export function StorefrontStatePage({ state, retry }: { state: StorefrontViewState; retry?: () => void }) {
  const details = content[state] ?? content["tenant-not-found"]!;
  const Icon = state === "api-error" ? ServerOff : state === "storefront-disabled" ? CircleOff : SearchX;
  const rootDomain = import.meta.env.VITE_ROOT_DOMAIN || "pos.elmortechnologies.com";
  const directoryHref = window.location.hostname === "localhost" || window.location.hostname.endsWith(".netlify.app")
    ? "/"
    : `https://store.${rootDomain}`;

  return (
    <main className="store-not-found">
      <div>
        <Icon />
        <p className="eyebrow">{details.eyebrow}</p>
        <h1>{details.title}</h1>
        <p>{details.description}</p>
        <div>
          {retry && <button className="button-primary" onClick={retry}>Try again</button>}
          <a className="button-secondary" href={directoryHref}>Browse stores</a>
        </div>
      </div>
    </main>
  );
}

export function DirectoryNotFoundPage() {
  return (
    <main className="store-not-found">
      <div>
        <SearchX />
        <p className="eyebrow">404</p>
        <h1>This directory page does not exist</h1>
        <p>Return to the store directory to choose an active storefront.</p>
        <div><a className="button-primary" href="/">Browse stores</a></div>
      </div>
    </main>
  );
}
